// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"d020320c","42":"f2cd1ac4","90":"d3112b22","216":"6077eb6d","267":"b9f64629","278":"76ef8741","330":"c54e79ff","389":"12d117d9","487":"38fd63c0","514":"72e1b02d","542":"bbdf3f97","588":"94a362da","715":"87a85001"}[chunkId] + ".chunk.js";
};